var _path, _path2, _circle, _path3, _circle2, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGadgets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 100,
    viewBox: "0 0 181 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.099 89.9692L137.098 89.9749C136.892 92.6924 134.449 94.9328 131.729 94.9328H4.98103C2.30127 94.9328 0.311535 92.7503 0.514201 90.0532C0.514272 90.0523 0.514344 90.0513 0.514416 90.0504L7.37478 11.4654C7.37481 11.4651 7.37484 11.4648 7.37486 11.4645C7.62331 8.73508 10.0309 6.5 12.7448 6.5H139.493C142.172 6.5 144.162 8.68215 143.959 11.3788C143.959 11.38 143.959 11.3812 143.959 11.3824L137.099 89.9692Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52 99L92 99",
    stroke: "#222222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 88,
    r: 2.5,
    stroke: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M176.018 92.454L176.018 92.454L176.018 92.4598C175.915 93.8105 174.693 94.9328 173.338 94.9328H150.698C149.383 94.9328 148.408 93.8684 148.507 92.538C148.507 92.5371 148.507 92.5362 148.507 92.5352L152.222 49.9806C152.222 49.9803 152.222 49.98 152.222 49.9797C152.346 48.6169 153.554 47.5 154.902 47.5H177.543C178.857 47.5 179.833 48.5644 179.734 49.8948C179.733 49.8957 179.733 49.8967 179.733 49.8976L176.018 92.454Z",
    stroke: "#222222"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 91,
    r: 1.5,
    stroke: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M171.648 87H154.092C152.841 87 151.912 86.0182 152.007 84.8182L154.888 53.1818C155.002 51.9818 156.101 51 157.352 51H174.908C176.159 51 177.088 51.9818 176.993 53.1818L174.112 84.8182C174.017 86.0182 172.899 87 171.648 87Z",
    fill: "#00A3E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.444 82H11.5165C8.81522 82 6.80972 79.9545 7.01437 77.4545L12.2355 18.5455C12.4811 16.0455 14.8549 14 17.5562 14H132.484C135.185 14 137.19 16.0455 136.986 18.5455L131.765 77.4545C131.56 79.9545 129.145 82 126.444 82Z",
    fill: "#00A3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGadgets);
export default __webpack_public_path__ + "static/media/gadgets.645ce2315a8a747e3e6bc499d1a87489.svg";
export { ForwardRef as ReactComponent };